import {BlockSelector, ESD_BLOCK_CONTAINER} from '../../constants/BlockName';
import {ImmutableHtmlNode} from '../../modifications/ImmutableNode';
import {BuiltInControl} from '../BuiltInControl';

export abstract class ContainerBuiltInControl extends BuiltInControl {
  public getTargetNodes(root: ImmutableHtmlNode): ImmutableHtmlNode[] {
    const containers = root.querySelectorAll(BlockSelector.CONTAINER);
    const container = root.asElement().hasClass(ESD_BLOCK_CONTAINER) ? [root] : [];
    return containers.length ? containers : container;
  };
}
